import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpc } from "@editor/utils/trpc";

import { skipToken } from "@tanstack/react-query";

const useDefaultCustomDomain = () => {
  const projectId = useCurrentProjectId();

  const { data: customDomainData } =
    trpc.v2CustomDomain.getByProjectId.useQuery(
      projectId ? { projectId } : skipToken,
    );

  const defaultCustomDomain = customDomainData?.customDomains[0];

  return defaultCustomDomain;
};

export default useDefaultCustomDomain;
